import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Box } from '@material-ui/core'
import { useStyles } from './styles'
import { Button } from 'src/components'
import { CowIcon } from 'src/assets/svg'
import ROUTES from 'src/constants/routes'

interface NotFoundProps {
  title?: string
  description?: string
  buttonLabel?: string
  onAction?: () => void
}

export const NotFound: React.FC<NotFoundProps> = ({
  title = 'Ops! Página não encontrada',
  description = 'Parece que você se perdeu no pasto! A página que você está procurando não existe ou foi movida para outro lugar.',
  buttonLabel = 'Página Inicial',
  onAction
}) => {
  const styles = useStyles()
  const navigate = useNavigate()

  const handleGoHome = () => {
    if (onAction) {
      onAction()
      return
    }
    navigate(ROUTES.DASHBOARD)
  }

  return (
    <Box className={styles.container}>
      <div className={styles.content}>
        <Box className={styles.iconContainer}>
          <Box className={styles.errorIcon}>
            <Typography variant='h1' className={styles.errorCode}>
              4
            </Typography>
            <Box className={styles.cowIconWrapper}>
              <CowIcon className={styles.cowIcon} />
            </Box>
            <Typography variant='h1' className={styles.errorCode}>
              4
            </Typography>
          </Box>
        </Box>
        <Typography variant='h2' className={styles.title}>
          {title}
        </Typography>
        <Typography variant='body1' className={styles.description}>
          {description}
        </Typography>
        <Box className={styles.actionsContainer}>
          <Button onClick={handleGoHome}>
            {buttonLabel}
          </Button>
        </Box>
      </div>
    </Box>
  )
}
